<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="page"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #table-header>
        <div class="actions">
          <el-button type="primary" size="mini" @click="handleAdd">新增</el-button>
        </div>
      </template>

      <template #colTitle="{ row }">
        <LanguageInputEcho v-if="row.type != 10000" :obj="row.title || {}" size="mini" />
        <span v-else>链接</span>
      </template>
      <template #colStatus="{ row }">
        <el-tag size="small" :type="getTagType(row.status)">{{ row.statusLabel }}</el-tag>
      </template>
      <template #colActions="{ row }">
        <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
        <el-button v-if="row.status === 1" type="text" size="small" @click="handleDeactivate(row)">停用</el-button>
        <el-button v-if="row.status === 2" type="text" size="small" @click="handleActivate(row)">启用</el-button>
        <el-button type="text" size="small" @click="handleDrawRecords(row)">记录</el-button>
        <el-popconfirm title="确定删除该活动？" @confirm="handleDelete(row)">
          <el-button
            v-show="row.status === 2"
            slot="reference"
            type="text"
            size="small"
            style="color: #f56c6c; padding-left: 8px"
          >
            删除
          </el-button>
        </el-popconfirm>
      </template>
    </SchemaTablePage>

    <ActivityCreateDialog
      :has-red-envelope-rain="hasRedEnvelopeRain"
      :has-agent-reward-box="hasAgentRewardBox"
      :has-loss-cashback="hasLossCashback"
      :has-total-deposit-reward="hasTotalDepositReward"
      :has-first-deposit-reward="hasFirstDepositReward"
      :has-spin-luck="hasSpinLuck"
      :has-sign-in="hasSignIn"
      :visible.sync="createDialogVisible"
      :mode="dialogMode"
      :activity-data="editingRow"
      @success="handleDialogSuccess"
    />
    <SpinLuckLogDialog :visible.sync="spinLuckLogDialogVisible" :act-id="spinLuckLogActId" :act-type="actType" />
  </div>
</template>

<script>
import { listAct, deleteAct, detailAct, updateAct } from '@/api/operation/activity'
import ActivityCreateDialog from '@/pages/admin/operation/components/ActivityCreateDialog.vue'
import SpinLuckLogDialog from '@/pages/admin/operation/components/SpinLuckLogDialog.vue'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'
import { Message } from 'element-ui'
import { ACT_TYPE_OPTIONS } from './const'
import LanguageInputEcho from '@/components/LanguageInputEcho/index.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

const STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 1, label: '启用' },
  { value: 2, label: '停用' },
]

const statusLabelMap = {
  1: '启用',
  2: '停用',
}

export default {
  name: 'ActivityManage',
  components: {
    ActivityCreateDialog,
    LanguageInputEcho,
    SchemaTablePage,
    SpinLuckLogDialog,
  },
  data() {
    return {
      ACT_TYPE_OPTIONS,
      hasRedEnvelopeRain: false,
      hasSignIn: false,
      hasAgentRewardBox: false,
      hasLossCashback: false,
      hasTotalDepositReward: false,
      hasFirstDepositReward: false,
      hasSpinLuck: false,
      defaultQuery: {
        title: '',
        type: '',
        status: '',
        activityTimeRange: [],
      },
      searchSchema: [
        {
          prop: 'title',
          label: '活动标题',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'type',
          label: '活动类型',
          component: 'select',
          componentProps: { clearable: false },
          options: [{ label: '全部', value: '' }, ...ACT_TYPE_OPTIONS],
        },
        {
          prop: 'status',
          label: '活动状态',
          component: 'select',
          componentProps: { clearable: true },
          options: STATUS_OPTIONS,
        },
        {
          prop: 'activityTimeRange',
          label: '活动时间',
          component: 'datetime-range',
          componentProps: { clearable: true },
          span: { xs: 24, sm: 12, md: 10 },
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { type: 'index', label: '序号', width: 60, resizable: false },
        { prop: 'title', label: '活动标题', minWidth: 200, resizable: true, slot: 'colTitle', align: 'left' },
        { prop: 'typeLabel', label: '活动类型', width: 110, resizable: false },
        { prop: 'timeRangeText', label: '活动时间', width: 280, resizable: false },
        { prop: 'statusLabel', label: '活动状态', width: 100, align: 'center', resizable: false, slot: 'colStatus' },
        { fixed: 'right', prop: 'action', label: '操作', width: 200, resizable: false, slot: 'colActions' },
      ],
      createDialogVisible: false,
      dialogMode: 'create',
      editingRow: null,
      spinLuckLogDialogVisible: false,
      actType: null,
      spinLuckLogActId: null,
    }
  },
  methods: {
    request(params) {
      return listAct(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
      }
      if (query.type !== '' && query.type != null) params.type = query.type
      if (query.title) params.title = query.title
      if (query.status !== '' && query.status != null) params.status = query.status
      if (Array.isArray(query.activityTimeRange) && query.activityTimeRange.length === 2) {
        const [start, end] = query.activityTimeRange
        const startAt = toUnixSeconds(start)
        const endAt = toUnixSeconds(end)
        if (startAt) params.start_at = startAt
        if (endAt) params.end_at = endAt
      }
      return params
    },
    parseResult(res) {
      const data = (res && res.data) || res
      const rawList = (data && data.list) || []
      const rawTotal = (data && data.total) != null ? data.total : 0
      return {
        list: Array.isArray(rawList) ? rawList.map(item => this.mapRow(item)) : [],
        total: rawTotal,
      }
    },
    mapRow(item) {
      const startAt = item.start_at
      const endAt = item.end_at
      const noTime = Number(startAt) === -1 && Number(endAt) === -1
      let timeRangeText = '永久有效'
      if (!noTime) {
        const s = formatTimestamp(startAt)
        const e = formatTimestamp(endAt)
        timeRangeText = s && e ? `${s} 至 ${e}` : s || e || '-'
      }
      return {
        ...item,
        sortKey: item.act_id != null ? item.act_id : item.id,
        typeLabel: ACT_TYPE_OPTIONS.find(opt => opt.value === item.type)?.label,
        statusLabel: statusLabelMap[item.status] != null ? statusLabelMap[item.status] : `状态${item.status}`,
        timeRangeText,
      }
    },
    getTagType(status) {
      return status === 1 ? 'success' : status === 2 ? 'danger' : 'info'
    },
    reloadTable() {
      this.$refs.tablePageRef?.reload?.()
    },
    handleDialogSuccess() {
      this.reloadTable()
    },
    handleAdd() {
      listAct({ page: 1, page_size: 100 }).then(res => {
        const redEnvelopeRainRes = res.data.list.find(item => item.type === 2)
        const spinLuckRes = res.data.list.find(item => item.type === 1)
        const agentRewardBoxRes = res.data.list.find(item => item.type === 6)
        const lossCashbackRes = res.data.list.find(item => item.type === 7)
        const totalDepositRewardRes = res.data.list.find(item => item.type === 8)
        const firstDepositRewardRes = res.data.list.find(item => item.type === 9)
        const signInRes = res.data.list.find(item => item.type === 4)

        this.hasRedEnvelopeRain = redEnvelopeRainRes ? true : false
        this.hasSpinLuck = spinLuckRes ? true : false
        this.hasAgentRewardBox = agentRewardBoxRes ? true : false
        this.hasLossCashback = lossCashbackRes ? true : false
        this.hasTotalDepositReward = totalDepositRewardRes ? true : false
        this.hasFirstDepositReward = firstDepositRewardRes ? true : false
        this.hasSignIn = signInRes ? true : false
        this.dialogMode = 'create'
        this.editingRow = null
        this.createDialogVisible = true
      })
    },
    async handleEdit(row) {
      const act_id = row.act_id
      this.dialogMode = 'edit'
      this.editingRow = null
      try {
        const res = await detailAct({ act_id })
        const data = (res && res.data) || res
        data.activityTimeRangeText =
          data.start_at && data.end_at ? `${formatTimestamp(data.start_at)}  至  ${formatTimestamp(data.end_at)}` : ''
        data.displayTimeRangeText =
          data.show_start_at && data.show_end_at
            ? `${formatTimestamp(data.show_start_at)} 至 ${formatTimestamp(data.show_end_at)}`
            : ''
        this.editingRow = data

        this.createDialogVisible = true
      } catch (e) {
        Message.error('获取活动详情失败')
      }
    },
    async handleDeactivate(row) {
      const act_id = row.act_id
      await updateAct({ act_id, status: 2 })
      Message.success('停用成功')
      this.reloadTable()
    },
    async handleActivate(row) {
      const act_id = row.act_id
      await updateAct({ act_id, status: 1 })
      Message.success('启用成功')
      this.reloadTable()
    },
    async handleDelete(row) {
      try {
        await deleteAct({ id: row.id })
        Message.success('删除成功')
        this.reloadTable()
      } catch (e) {
        /* request interceptor shows error */
      }
    },
    handleDrawRecords(row) {
      const act_id = row && row.act_id != null ? row.act_id : null
      if (act_id == null) {
        Message.error('缺少活动ID，无法查看记录')
        return
      }
      this.spinLuckLogActId = act_id
      this.spinLuckLogDialogVisible = true
      this.actType = row.type
    },
  },
}
</script>

<style lang="scss" scoped></style>
